export default __webpack_public_path__ + "static/force-usa-_medium_1-b304ee8f76953394f5516845c851169d.webp";